<svg class="cmn-icon" [style.width]="size()" [style.height]="size()"
    [attr.aria-hidden]="isDecorative() ? 'true' : null" [attr.aria-label]="ariaLabel()"
    [attr.role]="isDecorative() ? null : 'img'" [attr.viewBox]="viewBox()" focusable="false">
    @switch (name()) {
    @case (CmnIconName.Home) {
    <path d="M12 3 3 10v11h6v-6h6v6h6V10l-9-7Z" />
    }

    @case (CmnIconName.Bookmark) {
    <path d="M6 3h12v18l-6-4-6 4V3Z" />
    }

    @case (CmnIconName.Phone) {
    <path
        d="M6.6 10.8a15.3 15.3 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.2c1.1.4 2.3.6 3.6.6a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.6 21 3 13.4 3 4a1 1 0 0 1 1-1h3.4a1 1 0 0 1 1 1c0 1.3.2 2.5.6 3.6a1 1 0 0 1-.2 1l-2.2 2.2Z" />
    }

    @case (CmnIconName.Check) {
    <path d="M9.2 16.2 4.8 11.8 3.4 13.2 9.2 19 20.6 7.6 19.2 6.2z" />
    }

    @case (CmnIconName.Money) {
        <path d="M2.5 6.5h19v11h-19v-11Zm2 2v7h15v-7h-15Zm7.5 1.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6Zm-6.3.3h2.2v1.6H5.7V10Zm10.4 4.4h2.2V16h-2.2v-1.6Z"/>
    }

    @case (CmnIconName.ChevronDown) {
    <path d="M7.4 8.6 12 13.2l4.6-4.6L18 10l-6 6-6-6z" />
    }

    @case (CmnIconName.CheckCircle) {
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.3 14.3-4-4L8.1 11l2.6 2.6L15.9 8l1.4 1.4-6.6 6.9Z" />
    }

    @case (CmnIconName.CreditCard) {
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M3 5h18a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 21 19H3a1.5 1.5 0 0 1-1.5-1.5v-11A1.5 1.5 0 0 1 3 5Zm.5 2v10h17V7h-17Z" />
    <path d="M1.5 8.6h21v3h-21z" />
    <path d="M4 14h5v1.6H4z" />
    }

    @case (CmnIconName.PayPal) {
    <!-- Font Awesome 4 `fa-paypal` glyph (unicode f1ed). -->
    <g transform="translate(0 1536) scale(1 -1)">
      <path
        d="M1519 890q18 -84 -4 -204q-87 -444 -565 -444h-44q-25 0 -44 -16.5t-24 -42.5l-4 -19l-55 -346l-2 -15q-5 -26 -24.5 -42.5t-44.5 -16.5h-251q-21 0 -33 15t-9 36q9 56 26.5 168t26.5 168t27 167.5t27 167.5q5 37 43 37h131q133 -2 236 21q175 39 287 144q102 95 155 246q24 70 35 133q1 6 2.5 7.5t3.5 1t6 -3.5q79 -59 98 -162zM1347 1172q0 -107 -46 -236q-80 -233 -302 -315q-113 -40 -252 -42q0 -1 -90 -1l-90 1q-100 0 -118 -96q-2 -8 -85 -530q-1 -10 -12 -10h-295q-22 0 -36.5 16.5t-11.5 38.5l232 1471q5 29 27.5 48t51.5 19h598q34 0 97.5 -13t111.5 -32q107 -41 163.5 -123t56.5 -196z" />
    </g>
    }

    @case (CmnIconName.Venmo) {
    <!-- Font Awesome Free v7.3.1 `fa-venmo` by Fonticons, Inc. https://fontawesome.com/license/free -->
    <path
      d="M466.5 14.8c17.4 28.7 25.3 58.2 25.3 95.5 0 119-101.9 273.5-184.7 382.1l-188.9 0-75.8-451.5 165.4-15.7 40.1 321.3c37.4-60.8 83.6-156.3 83.6-221.4 0-35.6-6.1-59.9-15.7-79.9L466.5 14.8z" />
    }

    @case (CmnIconName.Mobile) {
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M7 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 3v12h8V5H8Zm4 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
    }

    @case (CmnIconName.Apple) {
    <path
        d="M16.4 12.6c0-2 1.6-3 1.7-3.1-1-1.4-2.4-1.6-2.9-1.6-1.3-.1-2.5.7-3.1.7-.6 0-1.6-.7-2.7-.7-1.4 0-2.7.8-3.4 2-1.4 2.5-.4 6.2 1 8.2.7 1 1.5 2.1 2.5 2.1 1 0 1.4-.6 2.6-.6s1.5.6 2.6.6c1.1 0 1.8-1 2.5-2 .8-1.1 1.1-2.2 1.1-2.3-.1 0-2.1-.8-2.1-3.3Z" />
    <path d="M14.6 6.3c.5-.7.9-1.6.8-2.5-.8 0-1.8.5-2.4 1.2-.5.6-1 1.6-.8 2.5.9.1 1.8-.5 2.4-1.2Z" />
    }

    @case (CmnIconName.Lock) {
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M12 2a4.5 4.5 0 0 0-4.5 4.5V9H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-1.5V6.5A4.5 4.5 0 0 0 12 2Zm2.5 7V6.5a2.5 2.5 0 0 0-5 0V9h5Zm-2.5 4.5a1.2 1.2 0 0 0-1.2 1.2c0 .5.3.9.7 1.1V18h1v-2.2c.4-.2.7-.6.7-1.1a1.2 1.2 0 0 0-1.2-1.2Z" />
    }
    }
</svg>